const t={width:56,height:56};export{t as LOGO_SIZE};
//# sourceMappingURL=constants.js.map
